module.exports = __webpack_public_path__ + "static/media/seaseekerlogo-removebg.3a78cd22.png";